import { StateFilterData } from '../forms/address/types';
import { IViewItemAnalytics } from '../analytics/types';
import LevelFirstForm from './LevelFirstForm';
import AnalyticsService from '../analytics/AnalyticsService';

interface PageConfig {
  stateFilterData: StateFilterData;
  viewItemAnalytics: IViewItemAnalytics;
}

window.tnew.page.initialize = function initialize({ stateFilterData, viewItemAnalytics }: PageConfig) {
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
  }

  const $form = document.querySelector('#tn-level-first-form') as HTMLFormElement;

  new LevelFirstForm($form, stateFilterData);
};
